<main>
  <div class="position-relative">
    <section class="section section-lg section-shaped pb-250 header-filter">
      <div class="container py-lg-sm d-flex">
        <div class="col px-0">
          <div class="row align-items-center justify-content-center">
            <!-- <div class="col-lg-12 text-center">
              <ngx-typed-js
                [strings]="[' Education Programme']"
                [loop]="true"
                [stringsElement]="null"
                [typeSpeed]="120"
                [startDelay]="1200"
                [backSpeed]="100"
                [backDelay]="150"
                [loop]="true"
                [loopCount]="false"
                [showCursor]="true"
                [fadeOut]="true"
                (completed)="doSmth()"
              >
                <h1 class="pre">
                  A Complete solution for <br />
                  <span class="typing"></span>
                </h1>
                <p class="lead text-white">
                  A Complete Solution for your Digital Vision.
                  <br />
                </p>
              </ngx-typed-js>
              <div class="btn-wrapper mt-5">
                <a
                  href="#contact"
                  class="btn btn-lg btn-danger btn-icon mb-3 mb-sm-0"
                >
                  <span class="btn-inner--icon"
                    ><i class="ni ni-curved-next"></i
                  ></span>
                  <span class="btn-inner--text">
                    <span class="text-default">Request</span> a Demo</span
                  >
                </a>
              </div>
            </div> -->
            <div class="row row-grid align-items-center">
              <div
                class="col-md-4 order-md-2"
                data-aos="fade-left"
                data-aos-delay="800"
              >
                <div class="floating-home">
                  <img
                    src="./../../../assets/img/backgroung/home_right-01.png"
                  />
                </div>
              </div>
              <div
                class="col-md-8 order-md-1"
                data-aos="fade-right"
                data-aos-delay="800"
              >
                <!-- <div class="pr-md-5">
                  <div
                    class="icon icon-lg icon-shape icon-shape-success shadow rounded-circle mb-5"
                  >
                    <i class="ni ni-settings-gear-65"></i>
                  </div>
                  <h3>About Us</h3>
                </div> -->
                <h1 class="pre">A Complete Solution For Education Programme</h1>
                <!-- <p class="lead text-white text-center">
                  A Complete Solution for your Digital Vision
                </p> -->
              </div>
            </div>
            <div class="col-lg-12 text-center">
              <div class="btn-wrapper mt-5">
                <a
                  href="#contact"
                  class="btn btn-lg btn-danger btn-icon mb-3 mb-sm-0"
                >
                  <span class="btn-inner--icon"
                    ><i class="ni ni-curved-next"></i
                  ></span>
                  <span class="btn-inner--text">
                    <span class="text-default">Request</span> a Demo</span
                  >
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="separator separator-bottom separator-skew">
        <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon class="fill-white" points="2560 0 2560 100 0 100"></polygon>
        </svg>
      </div>
    </section>
  </div>

  <section class="section">
    <div class="container">
      <div class="row row-grid align-items-center">
        <div
          class="col-md-6 order-md-2"
          data-aos="fade-left"
          data-aos-delay="800"
        >
          <div class="card bg-default shadow border-0 floating-about">
            <img
              src="./../../../assets/img/test/about.jpg"
              class="card-img-top"
            />

            <blockquote class="card-blockquote">
              <svg
                preserveAspectRatio="none"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 583 95"
                class="svg-bg"
              >
                <polygon points="0,52 583,95 0,95" class="fill-default" />
                <polygon
                  points="0,42 583,95 683,0 0,95"
                  opacity=".2"
                  class="fill-default"
                />
              </svg>
              <!-- <h4 class="display-3 font-weight-bold text-white">
                EDUVITA
              </h4> -->
              <div class="card-logo">
                <img
                  src="../../../assets/img/brand/eduvita_white.svg"
                  alt=""
                  srcset=""
                />
              </div>
              <p class="lead text-italic text-white">
                We provide all kind of softwares solution in one plateform also
                we respect skills that's why we take live class to spread more
                Education.
              </p>
            </blockquote>
          </div>
        </div>
        <div
          class="col-md-6 order-md-1"
          data-aos="fade-right"
          data-aos-delay="800"
        >
          <div class="pr-md-5">
            <div
              class="icon icon-lg icon-shape icon-shape-success shadow rounded-circle mb-5"
            >
              <i class="ni ni-settings-gear-65"></i>
            </div>
            <h3>About Us</h3>
            <p class="text-justify">
              Eduvita is an approachable and high performing
              <strong
                ><a title="Software Development company in India" href=""
                  >Software Development company in India</a
                ></strong
              >, with a passion for making specialist
              <strong>E-learning , ERP Software , Exam Portal</strong>
              development and also we have a package of IT solutions work for
              businesses and organizations. We are committed to providing best
              services, as well as a multitude of software designs attractive UI
              development to our clients worldwide. At
              <strong><a href="" title="EDUVITA">EDUVITA</a></strong
              >, we are focused on results.We strive to guarantee your 100
              percent satisfaction in terms of quality and timeline as per the
              decided deliverable.
            </p>
            <ul class="list-unstyled mt-5">
              <li class="py-2">
                <div class="d-flex align-items-center">
                  <div>
                    <div class="badge badge-circle badge-success mr-3">
                      <i class="ni ni-settings-gear-65"></i>
                    </div>
                  </div>
                  <div>
                    <h6 class="mb-0">Carefully crafted</h6>
                  </div>
                </div>
              </li>
              <li class="py-2">
                <div class="d-flex align-items-center">
                  <div>
                    <div class="badge badge-circle badge-success mr-3">
                      <i class="ni ni-html5"></i>
                    </div>
                  </div>
                  <div>
                    <h6 class="mb-0">Amazing UI / UX</h6>
                  </div>
                </div>
              </li>
              <li class="py-2">
                <div class="d-flex align-items-center">
                  <div>
                    <div class="badge badge-circle badge-success mr-3">
                      <i class="ni ni-satisfied"></i>
                    </div>
                  </div>
                  <div>
                    <h6 class="mb-0">Super friendly support team</h6>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section
    class="section pb-0 bg-gradient-warning"
    data-aos="fade-up"
    data-aos-delay="400"
  >
    <div class="container">
      <div class="row row-grid align-items-center">
        <div
          class="col-md-6 order-lg-2 ml-lg-auto"
          data-aos="fade-left"
          data-aos-delay="500"
        >
          <div class="position-relative pl-md-5">
            <img
              src="./assets/img/ill/ill-2.svg"
              class="img-center img-fluid floating-sm"
            />
          </div>
        </div>
        <div class="col-lg-6 order-lg-1">
          <div class="d-flex px-3">
            <div>
              <div
                class="icon icon-lg icon-shape bg-gradient-white shadow rounded-circle text-primary"
              >
                <i class="ni ni-building text-primary"></i>
              </div>
            </div>
            <div class="pl-4" data-aos="fade-down" data-aos-delay="600">
              <h4 class="display-3 text-white">Why Choose us</h4>
              <p class="text-white">
                We have highly skilled engineers with excellent technical
                knowledge and experience in using the latest software standards.
                We have built a large pool of knowledge that we apply to deliver
                solutions that meet client's needs, expectations and budget.
              </p>
            </div>
          </div>
          <div
            class="card shadow shadow-lg--hover mt-5"
            data-aos="fade-right"
            data-aos-delay="600"
          >
            <div class="card-body">
              <div class="d-flex px-3">
                <div>
                  <div
                    class="icon icon-shape bg-gradient-success rounded-circle text-white"
                  >
                    <i class="ni ni-satisfied"></i>
                  </div>
                </div>
                <div class="pl-4">
                  <h5 class="title text-success">Our Vision</h5>
                  <p class="text-justify">
                    As a world-class<strong
                      ><a
                        href="javascript:void(0)"
                        title="Software Development Company"
                      >
                        Software Development Company</a
                      ></strong
                    >
                    and IT service, our vision is to connect the education
                    system to the software. We want to give a digital vision to
                    our next generation.
                  </p>
                  <!-- <a href="javascript:void(0)" class="text-success"
                    >Learn more</a >-->
                </div>
              </div>
            </div>
          </div>
          <div
            class="card shadow shadow-lg--hover mt-5"
            data-aos="fade-right"
            data-aos-delay="600"
          >
            <div class="card-body">
              <div class="d-flex px-3">
                <div>
                  <div
                    class="icon icon-shape bg-gradient-warning rounded-circle text-white"
                  >
                    <i class="ni ni-active-40"></i>
                  </div>
                </div>
                <div class="pl-4">
                  <h5 class="title text-warning">
                    Our Mission
                  </h5>
                  <p class="text-justify">
                    Our prime mission is to provide innovative, pioneering and
                    unmatched Software Development and IT solutions to our
                    clients.
                  </p>
                  <!-- <a href="javascript:void(0)" class="text-warning"
                    >Learn more</a
                  > -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- SVG separator -->
    <div class="separator separator-bottom separator-skew zindex-100">
      <svg
        x="0"
        y="0"
        viewBox="0 0 2560 100"
        preserveAspectRatio="none"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <polygon class="fill-white" points="2560 0 2560 100 0 100"></polygon>
      </svg>
    </div>
  </section>
  <!-- Team Start -->
  <section class="section" data-aos="flip-left" data-aos-delay="800">
    <div class="container">
      <div class="row justify-content-center text-center mb-lg">
        <div class="col-lg-8">
          <h2 class="display-3">The amazing Team</h2>
          <!-- <p class="lead text-muted">
            According to the National Oceanic and Atmospheric Administration,
            Ted, Scambos, NSIDClead scentist, puts the potentially record
            maximum.
          </p> -->
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 col-lg-4 mb-5 mb-lg-0">
          <div class="px-4">
            <img
              src="./assets/img/theme/team-4-800x800.jpg"
              class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
              style="width: 200px;"
            />
            <div class="pt-4 text-center">
              <h5 class="title">
                <span class="d-block mb-1">Hemraj Singh Chouhan</span>
                <small class="h6 text-muted">Founder and CEO</small>
              </h5>
              <!-- <div class="mt-3">
                <a
                  href="javascript:void(0)"
                  class="btn btn-success btn-icon-only rounded-circle"
                >
                  <i class="fa fa-twitter"></i>
                </a>
                <a
                  href="javascript:void(0)"
                  class="btn btn-success btn-icon-only rounded-circle"
                >
                  <i class="fa fa-facebook"></i>
                </a>
                <a
                  href="javascript:void(0)"
                  class="btn btn-success btn-icon-only rounded-circle"
                >
                  <i class="fa fa-dribbble"></i>
                </a>
              </div> -->
            </div>
          </div>
        </div>
        <div class="col-md-6 col-lg-4 mb-5 mb-lg-0">
          <div class="px-4">
            <img
              src="./assets/img/theme/team-1-800x800.jpg"
              class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
              style="width: 200px;"
            />
            <div class="pt-4 text-center">
              <h5 class="title">
                <span class="d-block mb-1">Bhalendra Singh Rathore</span>
                <small class="h6 text-muted">Development Head </small>
              </h5>
              <!-- <div class="mt-3">
                <a
                  href="javascript:void(0)"
                  class="btn btn-warning btn-icon-only rounded-circle"
                >
                  <i class="fa fa-twitter"></i>
                </a>
                <a
                  href="javascript:void(0)"
                  class="btn btn-warning btn-icon-only rounded-circle"
                >
                  <i class="fa fa-facebook"></i>
                </a>
                <a
                  href="javascript:void(0)"
                  class="btn btn-warning btn-icon-only rounded-circle"
                >
                  <i class="fa fa-dribbble"></i>
                </a>
              </div> -->
            </div>
          </div>
        </div>
        <div class="col-md-6 col-lg-4 mb-5 mb-lg-0">
          <div class="px-4">
            <img
              src="./assets/img/theme/team-2-800x800.jpg"
              class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
              style="width: 200px;"
            />
            <div class="pt-4 text-center">
              <h5 class="title">
                <span class="d-block mb-1">Sonu Lodha</span>
                <small class="h6 text-muted">Developer</small>
              </h5>
              <!-- <div class="mt-3">
                <a
                  href="javascript:void(0)"
                  class="btn btn-primary btn-icon-only rounded-circle"
                >
                  <i class="fa fa-twitter"></i>
                </a>
                <a
                  href="javascript:void(0)"
                  class="btn btn-primary btn-icon-only rounded-circle"
                >
                  <i class="fa fa-facebook"></i>
                </a>
                <a
                  href="javascript:void(0)"
                  class="btn btn-primary btn-icon-only rounded-circle"
                >
                  <i class="fa fa-dribbble"></i>
                </a>
              </div> -->
            </div>
          </div>
        </div>
        <!-- <div class="col-md-6 col-lg-3 mb-5 mb-lg-0">
          <div class="px-4">
            <img
              src="./assets/img/theme/team-3-800x800.jpg"
              class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
              style="width: 200px;"
            />
            <div class="pt-4 text-center">
              <h5 class="title">
                <span class="d-block mb-1">Alexander Smith</span>
                <small class="h6 text-muted">UI/UX Designer</small>
              </h5>
              <div class="mt-3">
                <a
                  href="javascript:void(0)"
                  class="btn btn-info btn-icon-only rounded-circle"
                >
                  <i class="fa fa-twitter"></i>
                </a>
                <a
                  href="javascript:void(0)"
                  class="btn btn-info btn-icon-only rounded-circle"
                >
                  <i class="fa fa-facebook"></i>
                </a>
                <a
                  href="javascript:void(0)"
                  class="btn btn-info btn-icon-only rounded-circle"
                >
                  <i class="fa fa-dribbble"></i>
                </a>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </section>

  <!-- Call to action -->
  <section class="section pt-0" data-aos="zoom-in" data-aos-delay="800">
    <div class="container">
      <div class="card bg-gradient-warning shadow-lg border-0">
        <div class="p-5">
          <div class="row align-items-center">
            <div class="col-lg-8">
              <h3 class="text-white">
                Drive your online business to success.
              </h3>
              <p class="lead text-white mt-3">
                Contact us now to know all about our brilliant offerings
              </p>
            </div>
            <div class="col-lg-3 ml-lg-auto">
              <a href="#contact" class="btn btn-lg btn-block btn-white"
                >Get In Touch</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Services -->
  <section class="section bg-gradient-default" data-aos="zoom-in-right">
    <div class="container pt-lg pb-300">
      <div
        class="row text-center justify-content-center"
        data-aos="fade-down"
        data-aos-delay="1000"
      >
        <div class="col-lg-10">
          <h2 class="display-3 text-white">Our Prime Services</h2>
          <p class="lead text-white">
            We are offering all kind of education software services. Our all
            softwares are updated with latest technologies with 24X7 expert
            support. In this tech-savvy world, software development &
            advancement is helping businesses, small & large, reach great
            heights of success. Moreover, several organizations around the world
            are offering software development services.
          </p>
        </div>
      </div>
      <div class="row row-grid mt-5">
        <div class="col-lg-4" data-aos="flip-left" data-aos-delay="300">
          <div
            class="icon icon-lg icon-shape bg-gradient-white shadow rounded-circle text-primary"
          >
            <i class="ni ni-settings text-primary"></i>
          </div>
          <h5 class="text-white mt-3">ERP SOFTWARES</h5>
          <p class="text-white mt-3">
            Are you still relying on excel reports & multiple systems to manage
            your daily challenges? Well, it’s time for you to consider erp
            software for small business. Run your growing business on the most
            trusted, secure and complete ERP software in the world.
          </p>
        </div>
        <div class="col-lg-4" data-aos="flip-right" data-aos-delay="500">
          <div
            class="icon icon-lg icon-shape bg-gradient-white shadow rounded-circle text-primary"
          >
            <i class="ni ni-ruler-pencil text-primary"></i>
          </div>
          <h5 class="text-white mt-3">E-LEARNING</h5>
          <p class="text-white mt-3">
            E-learning is a biggest topic in corporate learning and development,
            human resources, and education, and we have the training experts to
            help you get your classes online with E-learning software. Create
            online training for your learners today.
          </p>
        </div>
        <div class="col-lg-4" data-aos="flip-left" data-aos-delay="800">
          <div
            class="icon icon-lg icon-shape bg-gradient-white shadow rounded-circle text-primary"
          >
            <i class="ni ni-atom text-primary"></i>
          </div>
          <h5 class="text-white mt-3">Exam Portal</h5>
          <p class="text-white mt-3">
            Get the feeling of real online exam with eduvita Online exam portal.
            Our Online exam portal provides support for all languages and
            mathematical equations. Hence you can create online exams, options,
            add equations etc in any language with up most ease.
          </p>
        </div>
      </div>
    </div>
    <!-- SVG separator -->
    <div class="separator separator-bottom separator-skew zindex-100">
      <svg
        x="0"
        y="0"
        viewBox="0 0 2560 100"
        preserveAspectRatio="none"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <polygon class="fill-white" points="2560 0 2560 100 0 100"></polygon>
      </svg>
    </div>
  </section>
  <!-- Contact Us -->
  <section
    class="section pt-lg-0 section-contact-us"
    id="contact"
    data-aos="flip-left"
    data-aos-easing="ease-out-cubic"
    data-aos-duration="3000"
  >
    <div class="container">
      <div class="row justify-content-center mt--300">
        <div class="col-lg-8">
          <div class="card bg-gradient-secondary shadow">
            <div class="card-body p-lg-5">
              <h4 class="mb-1">Want to try a demo?</h4>
              <p class="mt-0">Your intrest is very important to us.</p>
              <form
                class="form-group mt-5 has-success"
                [ngClass]="{ focused: focus === true }"
              >
                <div class="input-group input-group-alternative">
                  <div class="input-group-prepend">
                    <span class="input-group-text"
                      ><i class="ni ni-user-run"></i
                    ></span>
                  </div>
                  <input
                    class="form-control"
                    placeholder="Your name"
                    type="text"
                    (focus)="focus = true"
                    (blur)="focus = false"
                  />
                </div>
              </form>
              <div
                class="form-group has-success"
                [ngClass]="{ focused: focus1 === true }"
              >
                <div class="input-group input-group-alternative">
                  <div class="input-group-prepend">
                    <span class="input-group-text"
                      ><i class="ni ni-mobile-button"></i
                    ></span>
                  </div>
                  <input
                    class="form-control is-valid"
                    placeholder="+91 1234567890"
                    type="number"
                    (focus)="focus1 = true"
                    (blur)="focus1 = false"
                  />
                </div>
              </div>
              <div
                class="form-group has-success"
                [ngClass]="{ focused: focus1 === true }"
              >
                <div class="input-group input-group-alternative">
                  <div class="input-group-prepend">
                    <span class="input-group-text"
                      ><i class="ni ni-email-83"></i
                    ></span>
                  </div>
                  <input
                    class="form-control"
                    placeholder="Email address"
                    type="email"
                    (focus)="focus1 = true"
                    (blur)="focus1 = false"
                  />
                </div>
              </div>
              <div
                class="form-group has-success"
                [ngClass]="{ focused: focus1 === true }"
              >
                <div class="input-group input-group-alternative">
                  <div class="input-group-prepend">
                    <span class="input-group-text"
                      ><i class="ni ni-basket"></i
                    ></span>
                  </div>
                  <select class="form-control">
                    <option value="" disabled selected>Select Products</option>
                    <option value="1">E-learning Portal</option>
                    <option value="2">ERP Softwarte</option>
                    <option value="3">Exam Portal</option>
                    <option value="3">Live classes</option>
                    <option value="3">Website Design</option>
                    <option value="3">IT</option>
                  </select>
                </div>
              </div>

              <div class="form-group mb-4">
                <textarea
                  class="form-control form-control-alternative"
                  name="name"
                  rows="4"
                  cols="80"
                  placeholder="Type a message..."
                ></textarea>
              </div>
              <div>
                <button
                  type="button"
                  class="btn btn-default btn-round btn-block btn-lg"
                >
                  Send Message
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="section">
    <div class="container">
      <div class="row row-grid justify-content-center">
        <div class="col-lg-8 text-center">
          <div class="text-center">
            <h4 class="display-4 mb-5 mt-5">Available on these technologies</h4>
            <div class="row justify-content-center">
              <div class="col-lg-2 col-4">
                <a
                  href="javascript:void(0)"
                  placement="top"
                  ngbTooltip="Google Cloud Platform"
                >
                  <img
                    src="../../../assets/img/icons/google-cloud.png"
                    class="img-fluid"
                  />
                </a>
              </div>
              <div class="col-lg-2 col-4">
                <a
                  href="javascript:void(0)"
                  placement="top"
                  ngbTooltip="Bootstrap"
                >
                  <img
                    src="../../../assets/img/icons/bootstrap.jpg"
                    class="img-fluid"
                  />
                </a>
              </div>
              <div class="col-lg-2 col-4">
                <a
                  href="javascript:void(0)"
                  placement="top"
                  ngbTooltip="Angular 9"
                >
                  <img
                    src="../../../assets/img/icons/angular.jpg"
                    class="img-fluid"
                  />
                </a>
              </div>
              <div class="col-lg-2 col-4">
                <a href="javascript:void(0)" placement="top" ngbTooltip="React">
                  <img
                    src="../../../assets/img/icons/react.jpg"
                    class="img-fluid"
                  />
                </a>
              </div>
              <div class="col-lg-2 col-4">
                <a
                  href="javascript:void(0)"
                  placement="top"
                  ngbTooltip="[Coming Soon] Vue.js"
                >
                  <img
                    src="../../../assets/img/icons/vue.jpg"
                    class="img-fluid opacity-3"
                  />
                </a>
              </div>

              <div class="col-lg-2 col-4">
                <a
                  href="javascript:void(0)"
                  placement="top"
                  ngbTooltip="Amazon Web Services"
                >
                  <img
                    src="../../../assets/img/icons/aws.jpg"
                    class="img-fluid"
                  />
                </a>
              </div>
              <div class="col-lg-2 col-4">
                <a
                  href="javascript:void(0)"
                  placement="top"
                  ngbTooltip="Python"
                >
                  <img
                    src="../../../assets/img/icons/Python.png"
                    class="img-fluid"
                  />
                </a>
              </div>
              <div class="col-lg-2 col-4">
                <a href="javascript:void(0)" placement="top" ngbTooltip="Node">
                  <img
                    src="../../../assets/img/icons/node.png"
                    class="img-fluid"
                  />
                </a>
              </div>
              <div class="col-lg-2 col-4">
                <a
                  href="javascript:void(0)"
                  placement="top"
                  ngbTooltip="mongoDB"
                >
                  <img
                    src="../../../assets/img/icons/mongo.webp"
                    class="img-fluid"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>
